/**
 * @GENERATED from Figma node 3608:50997
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const DropboxDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#0061FF"
      d="m18 2-5.999 3.823 6 3.822L24 5.823zM18 9.645l-5.999 3.822 6 3.823L24 13.467zM6 2 .002 5.824l6 3.822 6-3.822z"
    />
    <path
      fill="#0061FF"
      d="m.001 13.467 6 3.823 6-3.823-6-3.822zM6 18.564l6.001 3.822 6-3.822-6-3.823z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(DropboxDark);
export { ForwardRef as DropboxDark };
